import React from "react";
import Link from "../../ui/Link/Link";

import styles from "./AuthLayout.module.scss";

export default function AuthLayout({ children }) {
  return (
    <div className={`${styles.container}`}>
      {children}
      <div className={`${styles.action}`}>
        <Link
          title="Условия использования"
          onClick={() => console.log("Условия использования")}
          className={`${styles.left_link}`}
        />
        |
        <Link
          title="Политика конфиденциальности"
          onClick={() => console.log("Политика конфиденциальности")}
          className={`${styles.right_link}`}
        />
      </div>
    </div>
  );
}
